'use strict';

const $sectionVisualSlide = document.querySelector('.section-visual-slide');
if ($sectionVisualSlide) {
  let option = {
    type: 'loop',
    focus: 'center',
    fixedWidth: '100%',
    gap: 0,
    speed: 400,
    autoplay: 'playing',
    interval: 4000,
    arrows: true,
    pagination: true,
    drag: true,
    mediaQuery: 'min',
    breakpoints: {
      750: {
        fixedWidth: '100%',
        gap: 0
      }
    }
  };
  new Splide($sectionVisualSlide, option).mount();
};